// cp1251Mixin.js
export default {
  methods: {
    encodeCP1251 (string) {
      function encodeChar (c) {
        const isKyr = function (str) {
          return /[а-я]/i.test(str);
        };
        const cp1251 = 'ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬*®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя';
        const p = isKyr(c) ? (cp1251.indexOf(c) + 128) : c.charCodeAt(0);
        let h = p.toString(16);
        if (h === 'a') {
          h = '0A';
        }
        return '%' + h;
      }
      let res = '';
      for (let i = 0; i < string.length; i++) {
        res += encodeChar(string.charAt(i));
      }
      return res;
    },
  },
};
